import React from "react";
import "./contact-card.css";

interface ContactCardProps {
    name: string;
    position: string;
    phone: string;
    mail: string;
    additional?: string;
}

const ContactCard:React.FC<ContactCardProps> = ({ name, position, phone, mail, additional}) => {
    return (
        <div className="contact-card">
            <div className="flex gap-4 items-end">
                <div className="contact-name">{name}</div>
                <div className="contact-position">{position}</div>
            </div>
            <div style={{display:"flex", gap: 8}}>
                <div className="contact-phone">{phone}</div>
                <div className="opacity-25">|</div>
                <div className="contact-mail">{mail}</div>
            </div>
            {additional && <div className="contact-additional">{additional}</div>}
        </div>
    )
}

export default ContactCard;